import React from "react";
import DashboardContent from "./DashboardContent";

const Dashboard = ({ children }) => {
  return <DashboardContent children={children} />;
};

export default Dashboard;
